import { createOpenAICompatibleProvider } from "./openAICompatibleProvider";
import { mistralCircuit } from "../../runtime/httpCircuitBreaker";

/**
 * Mistral provider. Activates automatically when MISTRAL_API_KEY is set.
 * Uses Mistral's OpenAI-compatible endpoint.
 */
export const mistralProvider = createOpenAICompatibleProvider({
  name: "mistral",
  apiKeyEnv: "MISTRAL_API_KEY",
  baseURL: "https://api.mistral.ai/v1",
  defaultModel: "mistral-large-latest",
  circuit: mistralCircuit,
  supportsJSON: true,
  supportsTools: true,
});
